import "../scss/style.scss";
import "./anime.js"
import "./splide_setting.js"
import "./splide-extension-auto-scroll.js"
import "./index.js"
import "./sec06_slide.js"
import "./dropdown.js"
